import React, { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import styles from './BulletList.module.scss';

interface RenderListProps {
  array: Record<string, unknown>;
  messageId: string;
  listStyleType?: 'disc' | 'decimal';
  size?: 'small' | 'default';
}

const BulletList = ({
  array,
  messageId,
  listStyleType = 'disc',
  size = 'default',
}: RenderListProps): ReactElement => {
  return (
    <ul className={styles[size]} style={{ listStyleType }}>
      {Object.keys(array).map((key) => {
        return (
          <li key={key}>
            <Message id={`${messageId}.${key}`} />
          </li>
        );
      })}
    </ul>
  );
};

export default BulletList;
